module.exports = __webpack_public_path__ + "img/sq5m_banner.3b66544b.jpg";